import * as types from '../../actions/actiontypes';
import initialState from '../initialstate';

export default function copyhubPackageFileSizeReducer(state = initialState.copyhubPackageFileSizes, action) {
	switch (action.type) {
		case types.GET_PACKAGE_FILE_SIZES: {
			return action.response;
		}
		default:
			return state;
	}
}
